<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="termsAndConditions"
      :items-length="totalItems"
      :search="search"
      density="compact"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
      show-expand
      single-expand
      item-value="id"
      v-model:expanded="expanded"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-terms-and-conditions") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.data-table-expand="{ item }">
        <v-icon
          @click="toggleExpand(item.id)"
          :loading="loadingDetails && selectedTerms === item.id"
        >
          {{ expanded.includes(item.id) ? mdiChevronUp : mdiChevronDown }}
        </v-icon>
      </template>

      <!-- estlint-disable-next-line -->
      <template v-slot:expanded-row="{ columns, item }">
        <tr v-if="expanded.includes(item.id)">
          <td :colspan="columns.length">
            <v-sheet elevation="9" class="mt-3 mb-3">
              <v-table>
                <thead>
                  <tr class="grey lighten-4">
                    <th>{{ $t("firstname") }}</th>
                    <th>{{ $t("name") }}</th>
                    <th>{{ $t("email") }}</th>
                    <th>{{ $t("accept") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(user, index) in acceptances"
                    :key="index"
                    class="grey lighten-4"
                  >
                    <td>
                      {{ user.user.firstName }}
                    </td>
                    <td>
                      {{ user.user.lastName }}
                    </td>
                    <td>
                      {{ user.user.email }}
                    </td>
                    <td>
                      <v-icon
                        color="#ffb500"
                        :icon="mdiCheckBold"
                        size="40"
                      ></v-icon>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-sheet>
          </td>
        </tr>
      </template>
      <template v-slot:item.fullText="{ item }">
        <span>{{ item.fullText.substring(0, 40) + "..." }}</span>
      </template>

      <template v-slot:item.versionDate="{ item }">
        <span>{{ new Date(item.versionDate).toLocaleDateString() }}</span>
      </template>

      <template v-slot:item.isActive="{ item }">
        <v-icon
          :color="item.isActive ? '#ffb500' : '#b2b4ae'"
          :icon="item.isActive ? mdiCheckBold : mdiCloseThick"
          size="40"
        ></v-icon>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <!-- <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon> -->
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'termsAndConditions'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-terms-and-conditions
      :modelDialog="termsAndConditionsDialog"
      @close="termsAndConditionsDialog = false"
    ></add-edit-terms-and-conditions>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import {
  mdiPencil,
  mdiDelete,
  mdiMagnify,
  mdiAccountPlus,
  mdiCheckBold,
  mdiCloseThick,
  mdiChevronUp,
  mdiChevronDown,
} from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import paginate from "@/mixins/paginations";
import AddEditTermsAndConditions from "./admin/AddEditTermsAndConditions.vue";

export default {
  name: "TermsAndConditionsAdmin",
  components: { AddEditTermsAndConditions, PaginationDynamic },
  mixins: [paginate],
  data() {
    return {
      mdiPencil,
      mdiDelete,
      mdiMagnify,
      mdiCloseThick,
      mdiCheckBold,
      mdiAccountPlus,
      mdiChevronUp,
      mdiChevronDown,
      expanded: [],
      selectedTerms: null,
      loadingDetails: false, // Indique si on attend les détails
      search: "",
      termsAndConditionsDialog: false,
      headers: [
        { title: "Version", key: "versionNumber" },
        { title: "Version Date", key: "versionDate" },
        { title: "Text", key: "fullText" },
        { title: "Actif", key: "isActive" },
        { title: "Actions", key: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    ...mapState({
      termsAndConditions: (state) => state.termsAndConditions.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      acceptances: (state) => state.termsAndConditions.acceptances,
      editedId: (state) => state.termsAndConditions.editedId,
    }),
  },
  watch: {
    selectedTerms(termAndCondition) {
      if (termAndCondition !== null) {
        this.getUserAcceptance(termAndCondition);
      }
    },
  },
  methods: {
    getUserAcceptance(termAndCondition) {
      if (!termAndCondition) return;
      this.loadingDetails = true;
      this.$store
        .dispatch("termsAndConditions/getUserAcceptanceList", termAndCondition)
        .then(() => {
          this.expanded = [termAndCondition]; // Développe uniquement après l'appel API
        })
        .finally(() => {
          this.loadingDetails = false;
        });
    },
    toggleExpand(termAndCondition) {
      if (this.loadingDetails) return;

      if (this.expanded.includes(termAndCondition)) {
        this.expanded = [];
        this.$store.commit("termsAndConditions/setAcceptances", []);
        this.selectedTerms = null; // Réinitialise la sélection
      } else {
        this.expanded = [termAndCondition]; // Développe immédiatement
        this.selectedTerms = termAndCondition; // Déclenche l'appel API
      }
    },
    toSort(item) {
      this.sortBy(item, "termsAndConditions");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "termsAndConditions");
    },
    deleteItem(item) {
      this.$store.commit("termsAndConditions/setEditedId", item.id);
    },
    editItem(item) {
      this.$store.commit("termsAndConditions/setEditedId", item.id);
      this.$store.commit(
        "termsAndConditions/setEditedItem",
        Object.assign({}, item),
      );
      this.termsAndConditionsDialog = true;
    },
    openDialog() {
      this.$store.commit("termsAndConditions/setEditedId", -1);
      this.$store.commit(
        "termsAndConditions/setEditedItem",
        Object.assign({}, this.$store.state.termsAndConditions.defaultItem),
      );
      this.termsAndConditionsDialog = true;
    },
  },
};
</script>
